/* Big Play Fest: gift-wrap + handwritten note toggle (cart drawer and /cart).
   Saves to cart attributes "Gift wrap" / "Gift note" via /cart/update.js.
   Bound once on document (delegation) so Dawn's drawer re-render, which swaps
   .drawer__inner wholesale, never leaves it unbound. */
(function () {
  if (window.csFestCartBound) return;
  window.csFestCartBound = true;

  var MAX = 150;
  var SEL = '[data-cs-fest-gift]';
  var state = null; // last user intent this page load: {on, note}
  var timer = null;
  var seq = 0;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function save(showSaved) {
    clearTimeout(timer);
    timer = null;
    if (!state) return Promise.resolve();
    var my = ++seq;
    var attrs = state.on
      ? { 'Gift wrap': 'Yes', 'Gift note': state.note.slice(0, MAX) }
      : { 'Gift wrap': '', 'Gift note': '' };
    return fetch(root() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs }),
    })
      .then(function (r) {
        if (my === seq && showSaved && r.ok) flashSaved();
      })
      .catch(function () {});
  }

  function later() {
    clearTimeout(timer);
    timer = setTimeout(function () { save(true); }, 700);
  }

  function flashSaved() {
    document.querySelectorAll('[data-cs-fest-gift-saved]').forEach(function (el) {
      el.classList.add('is-show');
      clearTimeout(el._t);
      el._t = setTimeout(function () { el.classList.remove('is-show'); }, 1400);
    });
  }

  // Push the in-memory state onto every instance (drawer + /cart, and any
  // fresh copy a re-render just inserted with a not-yet-saved note).
  function paint() {
    if (!state) return;
    document.querySelectorAll(SEL).forEach(function (box) {
      box.classList.toggle('is-on', state.on);
      var cb = box.querySelector('[data-cs-fest-gift-toggle]');
      var ta = box.querySelector('[data-cs-fest-gift-note]');
      var ct = box.querySelector('[data-cs-fest-gift-count]');
      if (cb && cb.checked !== state.on) cb.checked = state.on;
      if (ta && ta.value !== state.note && document.activeElement !== ta) ta.value = state.note;
      var c = state.note.length + '/' + MAX;
      if (ct && ct.textContent !== c) ct.textContent = c; // guarded: avoids observer loop
    });
  }

  function readFrom(box) {
    var cb = box.querySelector('[data-cs-fest-gift-toggle]');
    var ta = box.querySelector('[data-cs-fest-gift-note]');
    return { on: !!(cb && cb.checked), note: ta ? ta.value.slice(0, MAX) : '' };
  }

  // Capture phase: <cart-items>/<cart-drawer-items> treat every bubbling
  // "change" as a quantity edit. Stop ours before it gets there.
  document.addEventListener('change', function (e) {
    var box = e.target.closest && e.target.closest(SEL);
    if (!box) return;
    e.stopPropagation();
    state = readFrom(box);
    if (e.target.matches('[data-cs-fest-gift-toggle]')) {
      paint();
      save(false);
      if (state.on) {
        var ta = box.querySelector('[data-cs-fest-gift-note]');
        if (ta && !ta.value) setTimeout(function () { ta.focus({ preventScroll: true }); }, 30);
      }
    } else {
      paint();
      save(true);
    }
  }, true);

  document.addEventListener('input', function (e) {
    if (!e.target.matches || !e.target.matches('[data-cs-fest-gift-note]')) return;
    var box = e.target.closest(SEL);
    if (!box) return;
    if (e.target.value.length > MAX) e.target.value = e.target.value.slice(0, MAX);
    state = readFrom(box);
    paint();
    later();
  }, true);

  // Flush a pending note before the shopper leaves for checkout.
  document.addEventListener('click', function (e) {
    if (!timer) return;
    var t = e.target.closest && e.target.closest('[name="checkout"], .gokwik-checkout button, #gokwik-buy-now, .cart__ctas button, .cart__ctas a');
    if (t) save(false);
  }, true);
  window.addEventListener('pagehide', function () { if (timer) save(false); });

  // Re-render guard: when Dawn swaps in fresh HTML while a note is still
  // debouncing, the server copy is one keystroke behind. Re-apply our state.
  var mo = new MutationObserver(function () {
    if (state) paint();
  });
  function start() { mo.observe(document.body, { childList: true, subtree: true }); }
  if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);
})();
